import React from 'react'
import {Box, Breadcrumbs, Button, Container, Stack, Typography} from "@mui/material";
import {useNavigate, useParams} from "react-router-dom";
import ServiceDetailPlaceholder from "./ServiceDetailPlaceholder";
import {useServiceDetail} from "./hook/useServiceDetail";
import parse from "html-react-parser";
import {StarOutline} from "@mui/icons-material";
import StarIcon from "@mui/icons-material/Star";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

import './service-detail.css'
import Tags from "../tag/Tag";

const ServiceDetail = () => {
    const navigate = useNavigate();
    const {id, variant} = useParams()
    const {service, isLoading, addToFav, removeFromFav} = useServiceDetail(parseInt(id), variant);
    const {mode} = useDarkMode();
    console.log(service);
    return <Box id="service-detail">
        <Container maxWidth="lg" style={{paddingTop: 15}}>
            <Box sx={{marginBottom: '20px'}}>
                <Breadcrumbs separator="›" aria-label="breadcrumb" style={{color : mode.settings.textColor3}}>
                    {[
                        <Typography className={'breadcrumbs'} variant={'body2'} onClick={() => navigate('/')} style={{color : mode.settings.breadcrumbColor1}}>
                            Accueil
                        </Typography>,
                        <Typography className={'breadcrumbs'} variant={'body2'} onClick={() => navigate('/product-search')} style={{color : mode.settings.breadcrumbColor1}}>
                            Services
                        </Typography>,
                        <Typography className={'breadcrumbs'} variant={'body2'} style={{color : mode.settings.textColor3}}>
                            Détail
                        </Typography>,
                    ]}
                </Breadcrumbs>
                <Typography variant='h2' marginTop={5} sx={{marginBottom: '40px'}} style={{color : mode.settings.textColor3}}>
                    Détail Service
                </Typography>
            </Box>
            <Box sx={ {padding: "20px", backgroundColor: mode.settings.cardBackgroundColor} }>

                {
                    isLoading && <ServiceDetailPlaceholder/>
                }

                {
                    !isLoading && service && <Box className={`service-detail__${ service.presentation.toLowerCase().replace('_', '-') }`}>
                        <Stack
                            direction="row"
                            flexWrap={"wrap"}
                        >
                            <Box sx={{width : {xs : '100%', md : '100%', lg : '600px'}, height : {xs : '200px', md : '250px', lg : '440px'}}}>
                                <Box sx={{
                                    backgroundImage: `url(${service.image})`,
                                    backgroundSize: "cover",
                                    width: "100%",
                                    height: "100%",
                                }} />
                            </Box>
                            <Box sx={{width : {xs : '100%', md : '100%', lg : '40%'}}}>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    flexWrap={"wrap"}
                                    gap={2}
                                >

                                    <Stack
                                        alignItems={'center'}
                                        justifyContent={'flex-start'}
                                        flexWrap={"wrap"}
                                        gap={'10px'}
                                        direction="row"
                                    >
                                        <Tags tags={service.tags}/>
                                    </Stack>
                                    <Box sx={{minWidth : '300px'}}>
                                        {
                                            service && service.isFavorite &&
                                            <Button className="btn btn-fav" onClick={() => removeFromFav(id) } >
                                                <StarIcon role={'img'} aria-label="Enlever des favoris" />
                                                <Typography variant={'subtitle6'}>Enlever des favoris</Typography>
                                            </Button>
                                        }
                                        {
                                            service && !service.isFavorite &&
                                            <Button className="btn btn-fav" onClick={ () => addToFav(id) }>
                                                <StarOutline role={'img'} aria-label="Ajouter dans mes favoris" />
                                                <Typography variant={'subtitle6'}>Ajouter aux favoris</Typography>
                                            </Button>
                                        }
                                    </Box>
                                </Stack>
                                <Box className="service-detail__title">
                                    <Typography variant="h2" sx={{marginTop: '15px'}} style={{color : mode.settings.textColor3}}>
                                        {service.title}
                                    </Typography>
                                </Box>
                                <Box className="service-detail__description">
                                    <Typography component="p" style={{color : mode.settings.textColor3}}>
                                        {
                                            parse(service.description)
                                        }
                                    </Typography>
                                </Box>
                            </Box>
                        </Stack>
                    </Box>
                }
            </Box>
        </Container>
    </Box>
}

export default ServiceDetail
